export enum AttachmentTypeEnum {
  Video = 1,
  Audio = 2,
  File = 3,
  Image = 4,
  Flip = 5,
  Link = 6,
  Text = 7,
}
